/* eslint-disable no-console */
import { logger } from "../../utils/logger";

export const saveUserTimezone = (): void => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Check if localStorage is available
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem("userTimezone", timezone);
    } else {
      logger.warn("localStorage is not available.");
    }
  } catch (error) {
    logger.error("Error retrieving or saving timezone:", error);
  }
};
